let token = window.localStorage.getItem('token');
let configs = JSON.parse(window.localStorage.getItem('configs'));
let wsServerUrl = configs.wsServerUrl;

if (!token || !wsServerUrl) {
  alert('websocket消息缺少必要参数，请检查token和wsServerUrl是否存在');
}

let option = {
  query: {
    token,
  },
  transports: ['websocket'],
  path: '/socket',
};

let socket = io(`${wsServerUrl}/tip`, option);

// 连接事件
socket.on('connect', function () {
  console.log(
    `[websocket]连接成功，成功时间：${new Date().format('yyyy-MM-dd hh:mm:ss')}`
  );
});

// 连接失败事件
socket.on('connect_error', function (error) {
  console.error(
    `[websocket]连接失败，失败时间：${new Date().format(
      'yyyy-MM-dd hh:mm:ss'
    )}，错误原因：${error}`
  );
});

// 断开事件
socket.on('disconnect', function () {
  console.log(
    `[websocket]已断开，断开时间：${new Date().format('yyyy-MM-dd hh:mm:ss')}`
  );
});

// 尝试重连时触发事件
socket.on('reconnect_attempt', function (attempt) {
  console.log(`[websocket]重连中，当前第${attempt}次尝试重连`);
});

// 重连错误时触发事件
socket.on('reconnect_error', function (error) {
  console.error(
    `[websocket]重连失败，失败时间：${new Date().format(
      'yyyy-MM-dd hh:mm:ss'
    )}，错误原因：${error}`
  );
});

// 重连成功事件
socket.on('reconnect', function (attempt) {
  console.log(
    `[websocket]重连成功，成功时间：${new Date().format(
      'yyyy-MM-dd hh:mm:ss'
    )}，当前第${attempt}次重连`
  );
});

// 监听服务器端发送消息事件
socket.on('new_tip', function (data) {
  console.log(`[websocket]有新消息，消息内容：`, data);
});

// 日期格式化
Date.prototype.format = function (fmt) {
  var o = {
    'M+': this.getMonth() + 1, //月份
    'd+': this.getDate(), //日
    'h+': this.getHours(), //小时
    'm+': this.getMinutes(), //分
    's+': this.getSeconds(), //秒
    'q+': Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds(), //毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + '').substr(4 - RegExp.$1.length)
    );
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      );
    }
  }
  return fmt;
};

export default socket;
